import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapGlossaryTermSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapglossaryterm: {
      group: 'inline',
      inline: true,
      content: 'inline*',
      definingForContent: true,
      attrs: {
        glossterm: {
          default: undefined,
          exportedName: 'glossTerm',
          toEditorAttr(value) {
            // Use the camelCase attr name for glossTerm
            return { glossTerm: value };
          },
        }
      },
      parseDOM: [{
        tag: 'MadCap\\:glossaryTerm',
        getAttrs(dom: HTMLElement) {
          // For backwards compatibility the attribute name needs to stay all lowercase. But the attribute name on the element itself should be camelCase.
          // So read the attribute from the element with camelCase.
          // And then set it on the ProseMirror node with all lowercase.
          const attrs = getSchemaAttrs(dom, ['glossTerm']);
          return {
            glossterm: attrs['glossTerm']
          };
        },
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:glossaryTerm'
    }
  } satisfies Record<string, NodeSpec>;
}
